import Debug from 'debug';
import * as React from 'react';
import MDEditor from '@uiw/react-md-editor';
import {
  bold,
  checkedListCommand,
  divider,
  italic,
  link,
  orderedListCommand,
  quote,
  strikethrough,
  unorderedListCommand,
} from '@uiw/react-md-editor/commands';
import '@uiw/react-md-editor/markdown-editor.css';

const debug = Debug('gfe/fi/Richtext');

interface RichtextProps {
  className?: string;
  editorHeight?: number;
  handleChange: (newValue: string) => void;
  mandatory: boolean;
  validity?: boolean;
  value: string;
}

const SIMPLE_MARKDOWN_COMMANDS = [
  bold,
  italic,
  strikethrough,
  divider,
  link,
  quote,
  divider,
  unorderedListCommand,
  orderedListCommand,
  checkedListCommand,
];

export const Richtext: React.FC<RichtextProps> = (props) => {
  // debug(`Richtext ${props.value}`);
  return (
    <div className={props.className} data-color-mode="light">
      <MDEditor
        commands={SIMPLE_MARKDOWN_COMMANDS}
        extraCommands={[]}
        height={props.editorHeight || 130}
        preview="edit"
        value={String(props.value || '')}
        visibleDragbar={false}
        textareaProps={{
          placeholder: props.mandatory ? 'Enter a description' : undefined,
        }}
        onChange={(value) => props.handleChange(value || '')}
      />
    </div>
  );
};
